export interface QueryWork {
  regex: RegExp;
  addSpace: (val: string) => boolean;
}

const lastTwoNumbersRegex = /^\d{2}$/;
const ndRegex = /^[Nn][Dd]$/;

export class QueryWorkUtils {
  static getQueryWorkArr(isPasted: boolean): QueryWork[] {
    return [
      {
        regex: isPasted ? /^\d{3}$/ : /^\d{0,3}$/,
        addSpace: (val: string) => val.length === 3,
      },
      {
        regex: /^\d{0,2}$/,
        addSpace: (val: string) => val.length === 2,
      },
      {
        regex: /^[ZzRr]?[Rr]?\d{0,2}$/,
        addSpace: (val: string) => {
          if (val.length < 2) return false;
          return lastTwoNumbersRegex.test(val.slice(-2));
        },
      },
      {
        regex: /^(?![Dd])[Nn]?[Dd]?$|^\d{0,3}$/,
        addSpace: (val: string) => ndRegex.test(val) || val.length === 3,
      },
      {
        regex: /^[A-Za-z]?$/,
        addSpace: () => false,
      },
    ];
  }

  static addEndSpace(arrQueries: string[], isPasted: boolean): boolean {
    const queryWorkArr = this.getQueryWorkArr(isPasted);
    if (arrQueries.length < 1 || arrQueries.length > queryWorkArr.length) return false;
    const last = arrQueries.length - 1;
    return queryWorkArr[last].addSpace(arrQueries[last]);
  }

  static checkCorrectInput(arrQueries: string[], isPasted: boolean): boolean {
    const queryWorkArr = this.getQueryWorkArr(isPasted);
    if (arrQueries.length > queryWorkArr.length) return false;
    for (let i = 0; i < arrQueries.length; i++) {
      if (!queryWorkArr[i].regex.test(arrQueries[i])) return false;
    }
    return true;
  }
}
